module.exports = __webpack_public_path__ + "static/media/logo.e2e18ad9.svg";